import React, {
    useCallback, useEffect
} from 'react';
import _ from 'lodash';
import { WizardPage, wizardProps } from '@xengage/gw-portals-wizard-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { withRouter } from 'react-router-dom';

import { useUpdateSubmissionServices, validationUtil } from 'premier-capability-hooks';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { PremierConstants } from 'premier-constant-service';
import metadata from './LiabilityCoveragesPage.metadata.json5';
import messages from './LiabilityCoveragesPage.messages'
import styles from '../EquipmentBreakdown/EquipmentBreakdownPage.module.scss'
import AddlInterestTextBoxComponent from "../../components/AddlInterestTextBoxComponent/AddlInterestTextBoxComponent";
import CoveragesPageComponent from "../Coverages/CoveragesPage";

function LiabilityCoveragesPage(props) {

    const { wizardData: submissionVM, updateWizardData} = props;
    const { lineName } = PremierConstants;
    const { updateSubmission } = useUpdateSubmissionServices();
    const {
        onValidate,
        initialValidation
    } = useValidation('LiabilityCoveragesPage');

    const onNext = useCallback(
            async () => {
    
                const {productCode} = submissionVM.value.baseData;
                const lobLineName = lineName[productCode];
    
                submissionVM.value = await updateSubmission(lobLineName, 'PropertyCoveragesPage', submissionVM);
    
                return submissionVM;
            },
            [lineName, submissionVM, updateSubmission]
        );

    const onSave = useCallback(
        async () => {
            const subVMCopy = _.clone(submissionVM)
            const productCode = _.get(subVMCopy.value, 'baseData.productCode');

            validationUtil.unSetIsValidationReqFlag(subVMCopy.lobData.consTraAndServLine.coverables.additionalInterests.value, ' ')

            const lobLineName = productCode ? lineName[productCode] : '';

            await updateSubmission(lobLineName, 'LiabilityCoveragesPage', subVMCopy);
                            
            return submissionVM;
        },
        [lineName, submissionVM, updateSubmission]
    );

    useEffect(() => {

    }, []);

    const overrideProps = {
        pctLineCoverageComponent: {
            wizardData: submissionVM,
            updateWizardData,
            clausesBasePath: `lobData.consTraAndServLine.lineCoverages.coverages`,
            title: messages.covMiscellaneous,
            clasueType: 'coverages',
            pathToGet: 'consTraAndServLine.coverages'
        },
        additionalInterest:{
            wizardData: submissionVM,
            updateWizardData,
            addlIntPath: 'lobData.consTraAndServLine.coverables.additionalInterests',
            isLiaCov: true
        }
    };

    const resolvers = {
        resolveCallbackMap: {
            onValidate
        },
        resolveComponentMap: {
            CoveragesPageComponent,
            AddlInterestTextBoxComponent
        },
        resolveClassNameMap: styles
    };

    const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.pageContent, submissionVM, id, path, overrideProps),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [metadata, submissionVM, overrideProps]
    );


    const isDisableNext = () => !_.get(submissionVM, 'lobData.consTraAndServLine.coverables.additionalInterests.aspects.subtreeValid')
        || _.get(submissionVM.value, 'lobData.consTraAndServLine.coverables.additionalInterests')
            .some(addlInt => addlInt.arrFie === true &&
                (addlInt.arrAmoFie.amount === undefined || addlInt.arrAmoFie.amount === null || addlInt.arrAmoFie.amount === ''))

    return (
        <WizardPage onNext={onNext} onSave={onSave} skipWhen={initialValidation} disableNext={isDisableNext()}>
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={submissionVM}
                onModelChange={updateWizardData}
                overrideProps={overrideProps}
                onValidationChange={onValidate}
                resolveValue={readValue}
                callbackMap={resolvers.resolveCallbackMap}
                componentMap={resolvers.resolveComponentMap}
                classNameMap={resolvers.resolveClassNameMap}
            />
        </WizardPage>
    );
}

LiabilityCoveragesPage.propTypes = wizardProps;
export default withRouter(LiabilityCoveragesPage);
